var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatarFront(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 87.451,
    height: 88.142,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 226 228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer_x0020_1",
    fill: "none",
    stroke: "#999",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.72092,
    d: "M83 164c-3-3-7-9-10-13-3-6-2-8-4-11-1-1-3 8-9-10-4-8-8-22-8-30 0-5 6-4 9-5-19-39-4-40-5-46-3-23 4-37 31-46 17-6 47 1 66 7l-10 2c20 4 31 12 37 25 11 25 1 42-1 54l-3-6c-2-3-1-2-2-4l-6 17c4-1 6 0 7 4-3 10-5 18-8 28-3 8-5 12-9 6-4 13-8 20-15 28-7 7-18 24-30 19-10 3-25-14-30-19m10-26c15 1 27 1 40 0M1 227c7-13 20-14 33-18 22-6 34-10 38-16 5-6 6-11 11-29 7 8 19 22 30 19 10 4 23-11 30-19 6 18 5 24 11 30 4 4 30 12 38 14 14 4 26 6 33 19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarFront);
export default __webpack_public_path__ + "static/media/AvatarFront.76750ee750085ecdc1019ad304594d5d.svg";
export { ForwardRef as ReactComponent };